import { Modal, Button } from "antd";
import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}

export const ModalVisualizarAviso: React.FC<IProps> = (props: IProps) => {

  const forma = '/estimuloscultura/formato/FormatoRelacionResumenExperienciaProfesionalySoportesdocx_culturadoc9lss6oim5ogt3u3_202501.docx'

  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ textAlign: 'center', fontSize: '1.2em' }}>
        <p style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
          ¡Atención!
        </p>
        <br />
        <p>
          Por favor descargar y diligenciar el nuevo formato Relación Resumen Experiencia Profesional y Soportes. Luego agregarlo como una Experiencia Profesional.
        </p>
        <p>
          Sugerencias para  los campos:
        </p>
        <ol style={{textAlign: 'left'}}>
          <li> <strong>Nombre entidad:</strong> nombre del participante</li>
          <li> <strong>Fecha de inicio:</strong> fecha del primer soporte laboral</li>
          <li> <strong>Fecha terminación:</strong> fecha de último soporte laboral</li>
          <li> <strong>Cargo:</strong> el más relevante que ha desempeñado</li>
          <li> <strong>Funciones principales:</strong> las más relevantes que ha desempeñado</li>
        </ol>
        <p>
          Tener en cuenta que, además de diligenciar el formato, debe agregar la información y los soportes en la plataforma.
        </p>

        <Button
            className="button-yellow-ghost"
            style={{ paddingLeft: "0" }}
            onClick={() => {
                const link = document.createElement("a");
                link.href = forma
                link.download = "FormatoRelacionResumenExperienciaProfesional.docx"; // Nombre con el que se descargará
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }}
            >
            DESCARGAR FORMATO
        </Button>

        <br />
      </div>
    </Modal>
  );
};
